// extracted by mini-css-extract-plugin
export var divider = "_mr-0";
export var systemMessage = "_mr-1";